/* ══════════════════════════════════════════════════════════════════════════
   estate.js — shared estate kinds + re-exports for Fleet desks.
   Groups / Zones / Device desks live in fleet-*-desk.js (Soft≠Live).
   ══════════════════════════════════════════════════════════════════════════ */

/* One glyph, one colour and one silhouette per kind — an operator should be
   able to name what a pin is without reading its label.                     */
export const KINDS = {
  camera:  { t:"Camera",         glyph:"camera",  tone:"#3DE1C8", shape:"sq"  },
  contact: { t:"Door contact",   glyph:"door",    tone:"#7FD1FF", shape:"rect"},
  siren:   { t:"Siren",          glyph:"siren",   tone:"#FF9B5C", shape:"tri" },
  gateway: { t:"Mast / gateway", glyph:"mast",    tone:"#A78BFA", shape:"hex" },
  sensor:  { t:"Sensor",         glyph:"sensor",  tone:"#9BE37D", shape:"circ"},
  lidar:   { t:"Lidar",          glyph:"lidar",   tone:"#FFD166", shape:"oct" },
};
export const kindOf = k => KINDS[k] || { t:k, glyph:"chip", tone:"#8CA2A6", shape:"circ" };

/* Groups Soft≠Live Page70: FleetGroupsDesk lives in fleet-groups-desk.js (fleet.js mounts).
   Soft New-group toast theatre deleted. */

/* Zones Soft≠Live Page71: FleetZonesDesk in fleet-zones-desk.js (fleet.js mounts).
   Soft not-wired create theatre deleted — PUT/DELETE resource-fabric spaces · Live. */

/* Soft≠Live Page74: FleetDeviceDesk lives in fleet-device-desk.js (fleet + re-export).
   Soft useLive-only invent + age -1s deleted. */
export { Device, FleetDeviceDesk } from "./fleet-device-desk.js";
